<template>
  <subscription-list></subscription-list>
</template>

<script>

import SubscriptionList from './../../components/subscriptions/list'
export default {
  data: () => ({
  }),
  metaInfo() {
    return {
      title: this.$t('subscriptions.title')
    }
  },
  components: {
    SubscriptionList
  }
}
</script>